import React from "react";

interface Props {
  width: number;
  height: number;
}

const SvgProjects = (props: Props) => (
  <svg
    {...props}
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 24C13 20.6863 15.6863 18 19 18H35.8953C37.2577 18 38.5796 18.4637 39.6435 19.3148L46.3565 24.6852C47.4204 25.5363 48.7423 26 50.1047 26H77C80.3137 26 83 28.6863 83 32V72C83 75.3137 80.3137 78 77 78H19C15.6863 78 13 75.3137 13 72V24Z"
      fill="#EFB8C8"
    />
    <path
      d="M14 24C14 21.2386 16.2386 19 19 19H35.8953C37.0307 19 38.1322 19.3864 39.0188 20.0957L45.7318 25.4661C46.973 26.459 48.5152 27 50.1047 27H77C79.7614 27 82 29.2386 82 32V72C82 74.7614 79.7614 77 77 77H19C16.2386 77 14 74.7614 14 72V24Z"
      stroke="url(#paint0_linear_51383_2231)"
      strokeOpacity="0.1"
      strokeWidth="2"
    />
    <g filter="">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5625 44.0837C32.5625 41.6789 34.5119 39.7295 36.9167 39.7295H59.0833C61.4881 39.7295 63.4375 41.6789 63.4375 44.0837V59.917C63.4375 62.3217 61.4881 64.2712 59.0833 64.2712H36.9167C34.5119 64.2712 32.5625 62.3217 32.5625 59.917V44.0837ZM36.5208 44.8753C36.5208 44.2195 37.0525 43.6878 37.7083 43.6878C38.3642 43.6878 38.8958 44.2195 38.8958 44.8753C38.8958 45.5312 38.3642 46.0628 37.7083 46.0628C37.0525 46.0628 36.5208 45.5312 36.5208 44.8753ZM57.1042 44.8753C57.1042 44.2195 57.6358 43.6878 58.2917 43.6878C58.9475 43.6878 59.4792 44.2195 59.4792 44.8753C59.4792 45.5312 58.9475 46.0628 58.2917 46.0628C57.6358 46.0628 57.1042 45.5312 57.1042 44.8753ZM37.7083 48.4378C37.0525 48.4378 36.5208 48.9695 36.5208 49.6253C36.5208 50.2812 37.0525 50.8128 37.7083 50.8128C38.3642 50.8128 38.8958 50.2812 38.8958 49.6253C38.8958 48.9695 38.3642 48.4378 37.7083 48.4378ZM57.1042 49.6253C57.1042 48.9695 57.6358 48.4378 58.2917 48.4378C58.9475 48.4378 59.4792 48.9695 59.4792 49.6253C59.4792 50.2812 58.9475 50.8128 58.2917 50.8128C57.6358 50.8128 57.1042 50.2812 57.1042 49.6253ZM37.7083 53.1878C37.0525 53.1878 36.5208 53.7195 36.5208 54.3753C36.5208 55.0312 37.0525 55.5628 37.7083 55.5628C38.3642 55.5628 38.8958 55.0312 38.8958 54.3753C38.8958 53.7195 38.3642 53.1878 37.7083 53.1878ZM57.1042 54.3753C57.1042 53.7195 57.6358 53.1878 58.2917 53.1878C58.9475 53.1878 59.4792 53.7195 59.4792 54.3753C59.4792 55.0312 58.9475 55.5628 58.2917 55.5628C57.6358 55.5628 57.1042 55.0312 57.1042 54.3753ZM37.7083 57.9378C37.0525 57.9378 36.5208 58.4695 36.5208 59.1253C36.5208 59.7812 37.0525 60.3128 37.7083 60.3128C38.3642 60.3128 38.8958 59.7812 38.8958 59.1253C38.8958 58.4695 38.3642 57.9378 37.7083 57.9378ZM57.1042 59.1253C57.1042 58.4695 57.6358 57.9378 58.2917 57.9378C58.9475 57.9378 59.4792 58.4695 59.4792 59.1253C59.4792 59.7812 58.9475 60.3128 58.2917 60.3128C57.6358 60.3128 57.1042 59.7812 57.1042 59.1253ZM44.5979 56.6704C44.7898 56.9963 45.1967 57.0983 45.5083 56.8972L52.185 52.5909C52.273 52.534 52.3478 52.4563 52.402 52.3634C52.5932 52.0375 52.496 51.6103 52.185 51.4092L45.5083 47.103C45.4037 47.0357 45.284 47.0003 45.1616 47.0003C44.7964 47.0003 44.5 47.311 44.5 47.6938V56.307C44.5 56.4353 44.5337 56.5608 44.5979 56.6704Z"
        fill="url(#paint1_linear_51383_2231)"
        shapeRendering="geometricPrecision"
      />
    </g>
    <defs>
      <filter
        id="filter0_di_51383_2231"
        x="32.5625"
        y="39.7295"
        width="30.875"
        height="25.5415"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_51383_2231"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_51383_2231"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_51383_2231"
        />
      </filter>
      <linearGradient
        id="paint0_linear_51383_2231"
        x1="48"
        y1="18"
        x2="48"
        y2="78"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_51383_2231"
        x1="48"
        y1="39.7295"
        x2="48"
        y2="64.2712"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.9" />
        <stop offset="1" stopColor="white" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgProjects;
